export default "__VITE_ASSET__llC4YxHl__"